export class Login{
    correo: string;
    pass: string;
}